import { combineReducers } from 'redux';
import confirmToInviteReducer from './confirmToInviteReducer';
import inviteUserToRoleReducer from './inviteUserToRoleReducer';

export default combineReducers({
  confirmToInvite: confirmToInviteReducer,
  inviteUserToRole: inviteUserToRoleReducer,
});
